import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import scrollIntoView from 'scroll-into-view';
import queryString from 'query-string';
import PageHeader from '../../components/common/PageHeader';
import { AccountDetail, ResetPassword } from '../../components/AccountDetails';
import {
  cancelEmailChange,
  getAccountData,
  resendConfirmationEmail,
  resetPassword,
  getApiKey,
  generateApiKey,
  getJobProfileList
} from './actions';
import { clearMesage } from '../Layouts/actions';
import { constructData, getAccountDetails } from './helper';
import { keysIn, isEmpty, isEqual, get } from '../../utils/lodash';
import { validateAccountForm } from './validate';
import Loader from '../../components/Loader';
import SnakBar from '../../components/SnakBar';
import { Button } from '@material-ui/core';
import { forwardTo } from '../../utils/helper';
import I18n from '../../config/locales';
import { getValue } from '../../utils/localStorage';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  button: {
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(5)
  }
});

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountData: {},
      errorData: {},
      resetPasswordData: {
        old_pass: '',
        new_pass: '',
        new_pass_confirm: ''
      },
      passwordMismatch: false,
      enableConfirmPasswordField: false
    };
    this.initialLoad = true;
  }

  componentDidMount() {
    this.props.clearMesage();
    // Todo : Why we are calling this agai?
    this.props.getAccountData({ setCountry: false });
    this.props.getApiKey({ installerId: this.props.companyId });
    this.props.getJobProfiles({locale: getValue('locale_id')||'en'})
  }

  componentDidUpdate() {
    const { accountDetail, currentlySending } = this.props;
    if (!isEmpty(accountDetail) && !currentlySending && this.initialLoad) {
      this.setInitailData();
      this.initialLoad = false;
    }
  }

  componentWillUnmount() {
    this.initialLoad = true;
    this.setState({
      accountData: {},
      errorData: {}
    });
  }

  setInitailData = () => {
    const data = constructData(this.props);
    this.setState({ accountData: data });
  };

  findErrorKey = errors => {
    const errorKey = keysIn(errors).find(key => {
      return errors[key].error === true;
    });
    return errorKey;
  };

  handleSave = () => {
    const { companyId } = this.props;
    const data = {...this.state.accountData, account_details: this.props.accountDetail, show_job_profile: this.props.show_job_profile};
    const errors = validateAccountForm(this.state.errorData, { data });
    const errorKey = this.findErrorKey(errors);
    this.setState({ errorData: errors });
    if (!!!errorKey) {
      this.props.getAccountData({
        companyId,
        body: { account: data },
        isUpdate: true,
        successCbk: () => {
          this.props.getAccountData({ setCountry: false });
          data.email = get(this.props.accountDetail, 'email', '') || '';
          this.setState({ accountData: data });
        },
        failureCbk: () => {
          data.email = get(this.props.accountDetail, 'email', '') || '';
          this.setState({ accountData: data });
        }
      });
    } else {
      scrollIntoView(document.getElementById(errorKey));
    }
  };

  handleCancel = () => {
    this.setInitailData();
  };

  handleChange = (event, key) => {
    const data = this.state.accountData;
    data[key] = event.target.value;
    const errors = validateAccountForm(this.state.errorData, { data }, key);
    this.setState({ accountData: data, errorData: errors });
  };

  handlePasswordChange = (event, key) => {
    let value = event.target.value;
    let email = get(this.props.accountDetail, 'email', '') || '';
    value = value ? value.trim() : '';
    const password = this.state.resetPasswordData;
    password[key] = value;
    if (key === 'new_pass') {
      password['new_pass_confrim'] = '';
      this.setState({ resetPasswordData: password, passwordMismatch: false });

      const specialCharacter = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
      const numeric = /[0-9]/;
      const alphabet = /[a-zA-Z]/;
      if (
        value.length >= 6 &&
        value.length <= 50 &&
        alphabet.test(value) &&
        (specialCharacter.test(value) || numeric.test(value)) &&
        !isEqual(value, email)
      ) {
        this.setState({ enableConfirmPasswordField: true });
      } else {
        this.setState({ enableConfirmPasswordField: false });
      }
    } else if (key === 'old_pass') {
      this.setState({ resetPasswordData: password });
    } else {
      this.handleConfirmPasswordChange(event);
    }
  };

  handleConfirmPasswordChange = event => {
    const password = this.state.resetPasswordData;
    password['new_pass_confirm'] = event.target.value;
    this.setState({ resetPasswordData: password });
    if (!isEqual(password['new_pass'], password['new_pass_confirm'])) {
      this.setState({ passwordMismatch: true });
    } else {
      this.setState({ passwordMismatch: false });
    }
  };

  handleConfirmPasswordBlur = () => {
    const password = this.state.resetPasswordData;
    if (!isEqual(password['new_pass'], password['new_pass_confirm'])) {
      this.setState({ passwordMismatch: true });
    } else {
      this.setState({ passwordMismatch: false });
    }
  };
  handleReset = () => {
    const { resetPasswordData } = this.state;
    this.props.resetPassword({ companyId: this.props.companyId, body: resetPasswordData });
  };

  handleGenerateApiKey = () => {
    this.props.generateApiKey({ installerId: this.props.companyId });
  };

  renderAccountDetails = () => {
    const { masterData, apiKey, currentlySendingApiGenerateRequest, accountDetail, belongsToUs, jobProfileList, show_job_profile } = this.props;
    const accountDetails = getAccountDetails(this.state.accountData);
    return (
      <AccountDetail
        accountDetails={accountDetails}
        masterData={masterData}
        errorData={this.state.errorData}
        newEmail={get(this.props.accountDetail, 'new_email', null)}
        resendConfirmationEmail={this.props.resendConfirmationEmail}
        cancelEmailChange={this.props.cancelEmailChange}
        getAccountData={this.props.getAccountData}
        handleChange={this.handleChange}
        handleSave={this.handleSave}
        generateApiKey={this.handleGenerateApiKey}
        apiKey={apiKey}
        currentlySendingApiGenerateRequest={currentlySendingApiGenerateRequest}
        accountDetail={accountDetail}
        belongsToUs={belongsToUs}
        jobProfileList={jobProfileList}
        show_job_profile={show_job_profile}
      />
    );
  };

  renderResetPassword = () => (
    <ResetPassword
      handlePasswordChange={this.handlePasswordChange}
      resetPasswordData={this.state.resetPasswordData}
      handleReset={this.handleReset}
      passwordMismatch={this.state.passwordMismatch}
      enableConfirmPasswordField={this.state.enableConfirmPasswordField}
      handleConfirmPasswordChange={this.handleConfirmPasswordChange}
      handleConfirmPasswordBlur={this.handleConfirmPasswordBlur}
    />
  );

  render() {
    const { classes, currentlySending, messageType, message, location, isHomeowner, hideSnakbar } = this.props;
    // if (currentlySending) return <Loader loading={currentlySending} />;
    const { search } = location;
    const { platform = '', page = '' } = queryString.parse(search);
    const isITK = platform === 'itk';
    return (
      <div className={classes.root}>
        {!isITK && <PageHeader text={I18n.t('accountInfo.account')} />}
        {((isITK && page === 'profile') || !isITK) && this.renderAccountDetails()}
        {((isITK && page === 'change-password') || !isITK) && this.renderResetPassword()}
        {!hideSnakbar && message && messageType && !currentlySending && <SnakBar key={currentlySending} message={message} severity={messageType} />}
        {isHomeowner && (
          <Button
            className={classes.button}
            size="small"
            variant="contained"
            color="primary"
            onClick={() => {
              forwardTo('/manager/dashboard/preferences');
            }}
            disableElevation
          >
            {I18n.t('accountDetails.managePreferences')}
          </Button>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAccountData: payload => dispatch(getAccountData(payload)),
  resetPassword: payload => dispatch(resetPassword(payload)),
  resendConfirmationEmail: payload => dispatch(resendConfirmationEmail(payload)),
  cancelEmailChange: payload => dispatch(cancelEmailChange(payload)),
  clearMesage: () => dispatch(clearMesage()),
  getApiKey: payload => dispatch(getApiKey(payload)),
  generateApiKey: payload => dispatch(generateApiKey(payload)),
  getJobProfiles: payload => dispatch(getJobProfileList(payload))
});

const mapStateToProps = state => ({
  companyId: state.appReducer.companyId,
  currentlySending: state.accountReducer.currentlySending,
  currentlySendingApiGenerateRequest: state.accountReducer.currentlySendingApiGenerateRequest,
  accountDetail: state.accountReducer.accountDetail,
  message: state.accountReducer.message,
  messageType: state.accountReducer.messageType,
  isHomeowner: state.accountReducer.isHomeowner,
  hideSnakbar: state.accountReducer.hideSnakbar,
  apiKey: state.accountReducer.apiKey,
  belongsToUs: state.appReducer.belongsToUs,
  jobProfileList: state.accountReducer.job_profile_list,
  show_job_profile: state.accountReducer.show_job_profile
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(index));
